import app from '@/main'
import { get } from '@/utils/ajax'
import { loginEvent } from '@/utils/sensor'
export default {
  async logout({ commit }) {
    await app.$auth('logout')
    commit('LOGOUT')
  },
  // 获取b端的用户信息
  async getClassUserInfo({ state, commit }) {
    const user = await get('/edu/wap/profiles/users')
    loginEvent(user)
    commit('SET_USER', user)
    return state.user
  },
  // 获取c端的用户信息
  async getCodemaoUserInfo({ state, commit }) {
    const user = await app.$auth('get_profile')
    loginEvent(user)
    user.real_name = user.fullname
    commit('SET_USER', user)
    return state.user
  },
  // 获取c端的用户信息(私密信息)
  async getCodemaoAuthUserInfo({ state, commit }) {
    const user = await app.$auth('get_auth')
    loginEvent(user)
    user.phone = user.phone_number
    commit('SET_USER', user)
    return state.user
  },
  async getClassList({ state, commit }) {
    if (state.classData.length) return state.classData
    const data = await get('/edu/wap/report/student/class/info')
    commit('CLASSINFO', data)
  },
  // 上报点猫编程平台家长端使用情况
  async reportClassroomPageVisitParents({
    state: {
      user: {
        id,
        province_id,
        city_id,
        district_id,
        unit_id,
        unit_name,
        role_id,
        unit_type_id
      }
    },
    commit
  }) {
    window.caReport.add_event({
      key: 'parents_page_visit',
      segmentation: {
        province: province_id,
        city: city_id,
        district: district_id,
        unit_id,
        unit_name,
        type: unit_type_id,
        user_id: id,
        role_id,
        platform: 'H5',
        page:
          window.location.href.indexOf('?') !== -1
            ? window.location.href.split('?')[0]
            : window.location.href
      }
    })
  }
}
